import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ChoiceGrid, StepFooter, StepHeader } from "./_widgets";

const GOALS = [
  { value: "lose_fat", label: "Lose body fat" },
  { value: "build_muscle", label: "Build muscle" },
  { value: "recomp", label: "Recomposition", hint: "Lose fat & gain muscle" },
  { value: "athletic", label: "Improve athletic performance" },
  { value: "general", label: "General fitness" },
];

const PHYSIQUES = [
  { value: "lean", label: "Lean", hint: "Low fat, light muscle" },
  { value: "athletic", label: "Athletic", hint: "Toned, balanced" },
  { value: "muscular", label: "Muscular", hint: "Visible mass, strong" },
  { value: "very_muscular", label: "Very Muscular", hint: "Bodybuilder size" },
];

export default function Step2Goal({ data, set, onNext }) {
  const weightUnit = data.weight_unit || "lbs";
  const valid = !!data.primary_goal && !!data.physique_goal;
  return (
    <div className="space-y-5">
      <StepHeader title="Your Goal" subtitle="Pick what matters most right now." />

      <div className="space-y-1.5">
        <Label>Primary goal</Label>
        <ChoiceGrid
          options={GOALS}
          value={data.primary_goal}
          onChange={(v) => set({ primary_goal: v })}
          testid="onb-goal"
        />
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div className="space-y-1.5">
          <Label>
            Target weight{" "}
            <span className="text-muted-foreground font-normal text-xs">(optional · {weightUnit})</span>
          </Label>
          <Input
            type="number"
            placeholder={weightUnit === "lbs" ? "e.g. 165" : "e.g. 75"}
            value={data.target_weight}
            data-testid="onb-target-weight"
            onChange={(e) => set({ target_weight: e.target.value })}
          />
        </div>
        <div className="space-y-1.5">
          <Label>
            Target body fat{" "}
            <span className="text-muted-foreground font-normal text-xs">(optional · %)</span>
          </Label>
          <Input
            type="number"
            min={3}
            max={50}
            placeholder="e.g. 15"
            value={data.target_body_fat}
            data-testid="onb-target-bf"
            onChange={(e) => set({ target_body_fat: e.target.value })}
          />
        </div>
      </div>

      <div className="space-y-1.5">
        <Label>Which physique best matches your goal?</Label>
        <ChoiceGrid
          options={PHYSIQUES}
          value={data.physique_goal}
          onChange={(v) => set({ physique_goal: v })}
          columns={2}
          testid="onb-physique"
        />
      </div>

      <StepFooter valid={valid} onNext={onNext} />
    </div>
  );
}
